import { Route, BrowserRouter, Routes } from "react-router-dom";
import {
  Login,
  Register,
  Landing,
  Dashboard,
  Profile,
  Messages,
  Users,
  ValuationList,
  ValuationViewer,
  ValuationCreator,
  CityMap,
} from "./pages";

import PageView from "./components/pageView/PageView";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path='/' element={<Landing />} />

        <Route exact path='/login' element={<Login />} />
        <Route exact path='/register' element={<Register />} />

        <Route path='/panel' element={<PageView />}>
          <Route exact path={"/panel/dashboard"} element={<Dashboard />} />
          <Route exact path={"/panel/valuations"} element={<ValuationList />} />
          <Route exact path={"/panel/valuations/view/:id"} element={<ValuationViewer />} />
          <Route exact path={"/panel/valuations/new"} element={<ValuationCreator />} />
          <Route exact path={"/panel/messages"} element={<Messages />} />
          <Route exact path={"/panel/profile"} element={<Profile />} />
          <Route exact path={"/panel/users"} element={<Users />} />
          {/* <Route exact path={"/panel/map"} element={<CityMap />} /> */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
